import { Loading } from "../../../../assets/icons/Icons";
import formatoReclamacion from "../../../../assets/docs/Formato Reclamación.pdf"
import derechosAsegurado from "../../../../assets/docs/Derechos del asegurado.pdf"
import { useState } from "react";

const FormatosGuias = () => {

  const downloadCondicionesGenerales = async (documento) => {
    setDownloading(true);
    try {
        const response = await fetch(documento, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/pdf',
            },
        });

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;

        let fileName = documento.substring(documento.lastIndexOf('/') + 1).split('?')[0];
        fileName = fileName.split('.')[0] + '.pdf';

        a.download = fileName;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error al descargar archivo: ', error);
    } finally {
        setDownloading(false);
    }
};

      const [downloading, setDownloading] = useState(false)

    return (
        <>
            <div className="homeout__coberturas descargables m-auto">
                <p className="titulo__guias">Descargables:</p>
                <div className='d-lg-none d-block'><br/></div>
                <div className="div__botones">
                    <button className="btn__azul d-none d-md-block" onClick={() => downloadCondicionesGenerales(formatoReclamacion)}>{downloading ? <Loading/> : "FORMATO DE RECLAMACIÓN"}</button>
                    <button className="banner__button d-md-none" onClick={() => downloadCondicionesGenerales(formatoReclamacion)}>{downloading ? <Loading/> : "FORMATO DE RECLAMACIÓN"}</button>
                    <button className="btn__azul d-none d-md-block" onClick={() => downloadCondicionesGenerales(derechosAsegurado)}>{downloading ? <Loading/> : "DERECHOS DEL ASEGURADO"}</button>
                    <button className="banner__button d-md-none" onClick={() => downloadCondicionesGenerales(derechosAsegurado)}>{downloading ? <Loading/> : "DERECHOS DEL ASEGURADO"}</button>
                </div>
            </div>
        </>
    )
}

export default FormatosGuias